import { createPopper } from '@popperjs/core';
import 'bootstrap';
import * as CookieConsent from 'vanilla-cookieconsent';
import i18next from 'i18next';

import de from '../../locales/de/common.json';
import en from '../../locales/en/common.json';

i18next.init({
	lng: document.documentElement.lang || 'en',
	fallbackLng: 'en',
	returnObjects: true,
	resources: {
	  de: { translation: de },
	  en: { translation: en }
	}
  });

  
const CAT_NECESSARY = "necessary";
const CAT_ANALYTICS = "analytics";
const CAT_ADVERTISEMENT = "advertisement";
const CAT_FUNCTIONALITY = "functionality";
const CAT_SECURITY = "security";

const SERVICE_AD_STORAGE = 'ad_storage'
const SERVICE_AD_USER_DATA = 'ad_user_data'
const SERVICE_AD_PERSONALIZATION = 'ad_personalization'
const SERVICE_ANALYTICS_STORAGE = 'analytics_storage'
const SERVICE_FUNCTIONALITY_STORAGE = 'functionality_storage'
const SERVICE_PERSONALIZATION_STORAGE = 'personalization_storage'
const SERVICE_SECURITY_STORAGE = 'security_storage'


document.addEventListener('DOMContentLoaded', () => {

	window.dataLayer = window.dataLayer || [];
	function gtag(){dataLayer.push(arguments);}
	gtag('consent', 'default', {
		[SERVICE_AD_STORAGE]: 'denied',
		[SERVICE_AD_USER_DATA]: 'denied',
		[SERVICE_AD_PERSONALIZATION]: 'denied',
		[SERVICE_ANALYTICS_STORAGE]: 'denied',
		[SERVICE_FUNCTIONALITY_STORAGE]: 'denied',
		[SERVICE_PERSONALIZATION_STORAGE]: 'denied',
		[SERVICE_SECURITY_STORAGE]: 'denied',
	});

	CookieConsent.run({
		guiOptions: {
			consentModal: {
				layout: "box",
				position: "middle center",
				equalWeightButtons: true,
				flipButtons: false,
			},
			preferencesModal: {
				layout: "box",
				position: "right",
				equalWeightButtons: true,
				flipButtons: false
			}
		},
		hideFromBots: true,
		lazyHtmlGeneration: true,
		disablePageInteraction: true,
		onFirstConsent: () => {
			updateGtagConsent();
			toggleCrmPlaceholder();
		},
		onConsent: () => {
			updateGtagConsent();
			toggleCrmPlaceholder();
		},
		onChange: () => {
			updateGtagConsent();
			toggleCrmPlaceholder();
		},
		categories: {
			[CAT_NECESSARY]: {
				enabled: true,
				readOnly: true,
			},
			[CAT_ANALYTICS]: {
				autoClear: {
					cookies: [
						{
							name: /^_ga/,
						},
						{
							name: '_gid',
						}
					]
				},
				services: {
					[SERVICE_ANALYTICS_STORAGE]: {
						label: i18next.t('cookieconsent.services.analytics_storage.label')
					}
				}
			},
			marketing: {
				enabled: false,
				autoClear: true,
				services: {
				  recaptcha: {
					label: i18next.t('cookieconsent.services.recaptcha.label'),
					cookies: [
					  { name: /^_GRECAPTCHA/ }
					]
				  }
				}
			}
		},
		language: {
			default: 'en',
			autoDetect: 'document',
			translations: {
				de: i18next.t('cookieconsent', { returnObjects: true }),
				en: i18next.t('cookieconsent', { returnObjects: true })
			}
		}
	});

	document.getElementById("openConsent")?.addEventListener("click", () => {
		CookieConsent.show(true);
	});

	function updateGtagConsent() {
		gtag('consent', 'update', {
			[SERVICE_ANALYTICS_STORAGE]: CookieConsent.acceptedService(SERVICE_ANALYTICS_STORAGE, CAT_ANALYTICS) ? 'granted' : 'denied',
			[SERVICE_AD_STORAGE]: CookieConsent.acceptedService(SERVICE_AD_STORAGE, CAT_ADVERTISEMENT) ? 'granted' : 'denied',
			[SERVICE_AD_USER_DATA]: CookieConsent.acceptedService(SERVICE_AD_USER_DATA, CAT_ADVERTISEMENT) ? 'granted' : 'denied',
			[SERVICE_AD_PERSONALIZATION]: CookieConsent.acceptedService(SERVICE_AD_PERSONALIZATION, CAT_ADVERTISEMENT) ? 'granted' : 'denied',
			[SERVICE_FUNCTIONALITY_STORAGE]: CookieConsent.acceptedService(SERVICE_FUNCTIONALITY_STORAGE, CAT_FUNCTIONALITY) ? 'granted' : 'denied',
			[SERVICE_PERSONALIZATION_STORAGE]: CookieConsent.acceptedService(SERVICE_PERSONALIZATION_STORAGE, CAT_FUNCTIONALITY) ? 'granted' : 'denied',
			[SERVICE_SECURITY_STORAGE]: CookieConsent.acceptedService(SERVICE_SECURITY_STORAGE, CAT_SECURITY) ? 'granted' : 'denied',
		});
	}

	function toggleCrmPlaceholder() {
		const wrapper = document.getElementById("crmFormWrapper");
		if (!wrapper) return;
	  
		const placeholder = wrapper.querySelector(".crm-form-placeholder");
	  
		if (CookieConsent.acceptedCategory("marketing")) {
		  placeholder?.remove();
		} else {
		  if (!placeholder) {
			const div = document.createElement("div");
			div.className = "crm-form-placeholder";
			div.innerHTML = `
			  <p class="small">Das Kontaktformular ist nur verfügbar, wenn Sie Marketing-Cookies akzeptieren.</p>
			  <button id="openConsent" class="btn btn-secondary" type="button">Cookie-Einstellungen ändern</button>
			`;
			wrapper.prepend(div);
	  
			div.querySelector("#openConsent")?.addEventListener("click", () => {
			  CookieConsent.show(true);
			});
		  }
		}
	  }

	  (function(){

		function insertMail(id, codes) {
		  const email = String.fromCharCode.apply(null, codes);
		  const span = document.getElementById(id);
		  if (span) {
			span.innerHTML = '<a class="text-reset" href="mailto:' + email + '">' + email + '</a>';
		  }
		}
	  
		insertMail("mail-info", [105,110,102,111,64,113,105,118,97,108,111,110,46,100,101]);
	  
		insertMail("mail-join", [106,111,105,110,45,117,115,64,113,105,118,97,108,111,110,46,99,111,109]);
	  
	  })();
});

/*document.addEventListener('DOMContentLoaded', () => {

  // define feedback texts
  const texts = {
    'de': 'Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',
    'en': 'There has been an error. Please try again.',
    'pl': 'Wystąpił błąd. Proszę spróbować ponownie.',
  };

  // Fetch all the forms we want to apply custom Bootstrap validation styles to
  const forms = document.querySelectorAll('.needs-validation')
  // Loop over them and prevent submission
  Array.prototype.slice.call(forms)
    .forEach(function (form) {
      form.addEventListener('submit', function (event) {
        if (!form.checkValidity()) {
          event.preventDefault()
          event.stopPropagation()
					form.classList.add('was-validated')
        } else {
					// prepare query string from form data
					let data = new FormData(form);

          // append language to query string
          data.append('lang', document.documentElement.lang);

          // prepare html element for response
					let btnSubmit = form.querySelector('[type=submit]');
					let queryString = new URLSearchParams(data);
					let responseField = document.createElement('p');
					let responseFieldText = document.createElement('span');
					let responseFieldClose = document.createElement('button');

					responseField.classList.add('alert', 'alert-dismissible', 'small');
					responseFieldClose.classList.add('btn-close');
					responseFieldClose.setAttribute('data-bs-dismiss', 'alert');
          responseField.appendChild(responseFieldText);
          responseField.appendChild(responseFieldClose);

          // disable submit button
					btnSubmit.setAttribute('disabled', 'disabled');

					event.preventDefault();

          // ajax call with form content
					let xhr = new XMLHttpRequest;
          // if something goes wrong with request
					xhr.onerror = e => {
						responseField.classList.add('alert-danger', 'mt-4');
						responseFieldText.innerHTML = texts[document.documentElement.lang];
						console.log('Error '+xhr.status+': '+xhr.statusText);
						btnSubmit.removeAttribute('disabled');
						form.parentNode.insertBefore(responseField, form.nextSibling);
				  }
					xhr.onload = e => {
						if (xhr.status == 200) {
              // everything went fine
							responseField.classList.add('alert-success');
							responseFieldText.innerHTML = xhr.responseText;
							form.classList.add('d-none');
						} else {
              // if something is wrong with response
							responseField.classList.add('alert-danger', 'mt-4');
							responseFieldText.innerHTML = texts[document.documentElement.lang];
							console.log('Error '+xhr.status+': '+xhr.statusText);
							btnSubmit.removeAttribute('disabled');
						}
						form.parentNode.insertBefore(responseField, form.nextSibling);
					}
					xhr.open('POST', '/mailer/');
					xhr.send(queryString);
				}
      }, false);
    });
});*/
